import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail, ArrowRight, ArrowLeft, CheckCircle2, AlertCircle } from 'lucide-react';
import { authService } from '../services/api.service';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your admin email address.');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccessMsg('');

      const response = await authService.forgotPassword(email);
      
      setSuccessMsg(response.message || 'OTP sent successfully!');
      
      sessionStorage.setItem('resetEmail', email);

      setTimeout(() => {
        navigate('/admin/verify-otp', { state: { email, otp: response.otp } });
      }, 1500);
    } catch (err) {
      setError(err.message || 'Failed to send OTP. Please check your email address.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="infra-login-wrapper">
      {/* Left Split Hero Branding */}
      <div className="hero-section">
        <div className="hero-glow-effect"></div>
        <div className="hero-wave-overlay"></div>

        <div className="hero-content-layer">
          <div className="hero-logo">
            <div className="dots-grid-logo">
              {[...Array(9)].map((_, i) => (
                <div key={i} className="dot-red"></div>
              ))}
            </div>
            <div className="logo-text-container">
              <span className="logo-main-text">INFRAEDGE</span>
              <span className="logo-sub-text">RED LIGHT THERAPY</span>
            </div>
          </div>

          <div className="hero-main-body">
            <h1 className="hero-headline">
              Admin Password <span className="hero-headline-highlight">Recovery</span>
            </h1>
            <p className="hero-subheadline">
              Enter your registered admin email address to receive a 6-digit verification code to reset your account password.
            </p>
          </div>

          <div className="hero-footer-text" style={{ fontSize: '12px', color: '#64748b' }}>
            © 2026 InfraEdge Red Light Therapy Inc. All rights reserved.
          </div>
        </div>

      </div>

      {/* Right Split Form */}
      <div className="form-section">
        <div className="login-form-card">
          <div className="form-header">
            <h2 className="form-title">Forgot Password?</h2>
            <p className="form-subtitle">Don't worry, we'll send you verification instructions.</p>
          </div>

          {error && (
            <div className="form-alert">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          {successMsg && (
            <div className="form-alert" style={{ background: '#ecfdf5', borderColor: '#a7f3d0', color: '#047857' }}>
              <CheckCircle2 size={16} />
              <span>{successMsg}</span>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="input-label">Admin Email Address</label>
              <div className="input-field-wrapper">
                <Mail className="field-icon" size={18} />
                <input
                  type="email"
                  className="styled-input"
                  placeholder="Info@infraedgeredlight.co.uk"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn-red-submit" disabled={loading}>
              {loading ? (
                <div className="spinner-white"></div>
              ) : (
                <>
                  <span>Send OTP Verification Code</span>
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>

          <div style={{ marginTop: '24px', textAlignment: 'center' }}>
            <Link to="/admin/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#64748b', fontSize: '13px', fontWeight: 600, textDecoration: 'none' }}>
              <ArrowLeft size={16} />
              <span>Back to Login</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
